// extracted by css-extract-rspack-plugin
export default {"ResultsSectionsWrapper":"GlobalSearch_ResultsSectionsWrapper__2BBmB"};